import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, OnInit, Inject, ViewChild, AfterViewInit, ViewContainerRef} from '@angular/core';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'optionsDialog',
  templateUrl:  './optionsDialog.components.html',
  styleUrls: ['./optionsDialog.components.css']
})
export class OptionsDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef }) dynamicComponent: ViewContainerRef;
  title: string;
  content: any;
  buttons: any;
  public componentInstanz

  constructor(
    public dialogRef: MatDialogRef<OptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Update view with given values
    this.title = data.title;
    this.content = data.content;
    this.buttons = data.buttons;
  }

  ngOnInit() {
    this.btnDeklarieren()
  }

  ngAfterViewInit() {
    this.componentInstanz = this.dynamicComponent.createComponent(this.data.content)
  }

  public btnFunktion(btn){
    if (btn){
      this.dialogRef.close(this.componentInstanz)
    }
  }

  public btnDeklarieren(){
    let neueBtnListe = []
    for (let button of Object.entries(this.buttons)){
      neueBtnListe.push(
        {label: button[0], color: button[1][0], param: button[1][1]}
      )
    }
    this.buttons = neueBtnListe
  }

  protected readonly environment = environment;
}
